export default __webpack_public_path__ + "static/media/ArrowUp.94980391.svg";